import { useMutation, useQueryClient } from 'react-query';
import { joinElearning } from 'src/common/services/elearning';
import { getUserElearningPageRoute } from 'src/user/routes';
import { QueryKey } from 'src/config/queryKey';
import { useGatsbyLikeNavigate } from 'src/common/migration/useGatsbyLikeNavigate';

export const useJoinElearningMutation = (elearningId: number) => {
  const navigate = useGatsbyLikeNavigate();
  const queryClient = useQueryClient();

  return useMutation(() => joinElearning(elearningId), {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKey.Elearning, elearningId]);
      navigate(getUserElearningPageRoute(String(elearningId)), { replace: true });
    },
  });
};
